import React, { useEffect } from 'react'
import SideBar from '../Components/Profile/SideBar.jsx'
import { Outlet, useNavigate } from 'react-router-dom'
import Navbar from '../Components/Core/Navbar.jsx';
import Footer from '../Components/Core/Footer.jsx';
import '../Styles/Home.css';


function ProfilePage() {

 const accessToken = localStorage.getItem("accessToken");

  const navigate=useNavigate();
  
useEffect(()=>{

 
   if(!accessToken){
    navigate('/login')
    return
  
  }
  
},[])


  return (
    <div id="wb-container" className="wb-effect10">
   <Navbar/>
    <div className='profile-page-container'
    style={{width:'109vw',position:"relative",display:'flex',gap:'10px'}}>
        <SideBar/>
        <div style={{width:'109vw',padding:"14px"}}>
        <Outlet/>
        </div>
    </div>
   <Footer/>
    </div>
  )
}

export default ProfilePage